// ═══════════════════════════════════════════════════════════════════════════
//  aiField — Constants & Model Definitions
// ═══════════════════════════════════════════════════════════════════════════

export const IMG_MODELS = [
  // ── Nano Banana (Google-powered) ──
  {
    id: 'nano-banana', label: 'Nano Banana', desc: 'Everyday basics.', cost: 12, color: '#c084fc', icon: 'Banana',
    maxRefs: 10, hideResolution: true
  },
  {
    id: 'nano-banana-2', label: 'Nano Banana 2', desc: 'Versatile all-rounder.', cost: 14, color: '#a78bfa', icon: 'Banana',
    maxRefs: 10, resolutions: ['1k', '2k', '4k'], resPrices: { '1k': 14, '2k': 22, '4k': 40 }
  },
  {
    id: 'nano-banana-pro', label: 'Nano Banana Pro', desc: 'Ultimate detail.', cost: 24, color: '#f97316', tag: 'Pro', icon: 'Banana',
    maxRefs: 14, resolutions: ['1k', '2k', '4k'], resPrices: { '1k': 24, '2k': 30, '4k': 50 }
  },

  // ── Grok (xAI) ──
  {
    id: 'grok-imagine', label: 'Grok Imagine', desc: 'Creative & controversial.', cost: 12, color: '#e5e7eb', icon: 'Grok',
    maxRefs: 4, resolutions: ['1k', '2k'], hasNsfw: true
  },

  // ── Flux 2 (BFL) ──
  {
    id: 'flux-2-max', label: 'Flux 2 Max', desc: 'Cinematic photorealism.', cost: 22, color: '#f472b6', tag: 'Premium', icon: 'Flux',
    maxRefs: 8, resolutions: ['1k', '2k'], resPrices: { '1k': 22, '2k': 32 }
  },
  {
    id: 'flux-2-pro', label: 'Flux 2 Pro', desc: 'Professional precision.', cost: 14, color: '#818cf8', popular: true, icon: 'Flux',
    maxRefs: 8, resolutions: ['1k', '2k'], resPrices: { '1k': 14, '2k': 28 }
  },
  {
    id: 'flux-2-flex', label: 'Flux 2 Flex', desc: 'Fast & adaptable.', cost: 20, color: '#38bdf8', icon: 'Flux',
    maxRefs: 8, resolutions: ['1k', '2k'], resPrices: { '1k': 20, '2k': 45 }
  },
  {
    id: 'flux-2-klein', label: 'Flux 2 Klein 9B', desc: 'Instant generation.', cost: 10, color: '#22d3ee', icon: 'Flux',
    maxRefs: 4, resolutions: ['1k', '2k']
  },

  // ── New Models (Kie API) ──
  // { id:'grok-imagine',     label:'Grok Imagine',     cost:3, color:'#e5e7eb', icon: 'Grok',
  //   maxRefs: 4, resolutions: ['1k', '2k'] },
  // { id:'openai-4o-image',  label:'OpenAI 4o Image',  cost:8, color:'#10a37f', icon: 'OpenAI',
  //   maxRefs: 1, ratios: ['3:2', '2:3', '1:1'], hideResolution: true },
  // { id:'seedream-5-lite',  label:'Seedream 5.0 Lite', desc:'Quick drafts.', cost:14, color:'#22d3ee', icon: 'Seedream',
  //   maxRefs: 14, ratios: ['9:16','2:3','3:4','4:5','1:1','5:4','4:3','3:2','16:9','21:9'], resolutions: ['2k', '4k'], resPrices: { '2k': 14, '4k': 26 } },
  {
    id: 'seedream-4.5', label: 'Seedream 4.5', desc: 'Digital art.', cost: 16, color: '#06b6d4', icon: 'Seedream',
    maxRefs: 14, ratios: ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'], resolutions: ['2k', '4k'], resPrices: { '2k': 16, '4k': 28 }, hasNsfw: true
  },
  // { id:'google-imagen-4',  label:'Google Imagen 4',  cost:6, color:'#4285F4', icon: 'G', popular:true,
  //   maxRefs: 0, ratios: ['9:16','3:4','1:1','4:3','16:9'], hideResolution: true },
  // { id:'gpt-image-1.5',    label:'GPT Image 1.5',    cost:6, color:'#10a37f', tag:'Pro', icon: 'OpenAI',
  //   maxRefs: 16, ratios: ['2:3','1:1','3:2'], hideResolution: true, hasQuality: true },
  {
    id: 'qwen-z-image', label: 'Qwen Z-Image', desc: 'Multilingual & cultural.', cost: 8, color: '#10a37f', tag: 'New', icon: 'Qwen',
    maxRefs: 0, ratios: ['9:16', '3:4', '1:1', '4:3', '16:9'], hideResolution: true
  },
  {
    id: 'gpt-image-2', label: 'GPT Image 2', desc: 'High quality GPT generation.', cost: 25, color: '#10a37f', tag: 'New', icon: 'GPT',
    maxRefs: 16, ratios: ['9:16', '2:3', '3:4', '4:5', '1:1', '5:4', '4:3', '3:2', '16:9'], hideResolution: true, hasQuality: true,
    // Quality-based pricing: low=10, medium=25, high varies by aspect ratio
    qualityCosts: { low: 10, medium: 25, high: 40 },
    qualityCostWide: 40,   // high quality for 16:9 or 9:16
    qualityCostOther: 50,  // high quality for all other aspect ratios
  },
];

export const VID_MODELS = [
  { id: 'kling-2.1', label: 'Kling 2.1', baseCost: 10, color: '#38bdf8', multiShot: false, icon: 'Kling' },
  { id: 'kling-2.6', label: 'Kling 2.6', baseCost: 10, color: '#22d3ee', multiShot: false, icon: 'Kling', tag: 'New' },
  { id: 'kling-3', label: 'Kling 3.0', baseCost: 10, color: '#06b6d4', multiShot: true, maxShots: 5, icon: 'Kling' },
  // { id:'veo-3.1',     label:'Veo 3.1',      baseCost:12, color:'#a78bfa', multiShot:false, icon: 'G' },
  { id: 'wan-2.7', label: 'Wan 2.7', baseCost: 10, color: '#f472b6', multiShot: false, icon: 'Wan' },
  {
    id: 'seedance-2',
    label: 'Seedance 2',
    baseCost: 70, 
    color: '#38bdf8',
    icon: 'Seedream',
    desc: 'Standard quality. 480p: 25–35cr/s · 720p: 45–70cr/s · 1080p: 90-140cr/s',
    resolutions: ['480p', '720p', '1080p'],
    aspectRatios: ['1:1', '4:3', '3:4', '16:9', '9:16', '21:9', 'adaptive'],
  },
  {
    id: 'seedance-2-fast',
    label: 'Seedance 2 Fast',
    baseCost: 70, // this baseCost doesn't affect calculation, but just for consistency
    color: '#22d3ee',
    icon: 'Seedream',
    tag: 'Fast',
    desc: '480p: 25–35cr/s · 720p: 45–70cr/s',
    resolutions: ['480p', '720p'],
    aspectRatios: ['1:1', '4:3', '3:4', '16:9', '9:16', '21:9', 'adaptive'],
  },

];

export const EDIT_VIDEO_MODELS = [
  { id: 'wan-2.7', label: 'Wan 2.7', baseCost: 10, color: '#f472b6', icon: 'Wan' },
];

export const LIPS_MODELS = [
  { id: 'kling-avatar', label: 'Kling AI Avatar', baseCost: 30, color: '#06b6d4', icon: 'Kling' },
  { id: 'meigen-ai-infinitetalk', label: 'MeiGen-AI InfiniteTalk', baseCost: 25, color: '#f472b6', icon: 'Sparkle' },
  // { id:'wan-2.2', label:'Wan 2.2', baseCost: 12, color: '#a78bfa', icon: 'Wand' },
];

export const MOTION_MODELS = [
  { id: 'kling-3.0', label: 'Kling 3.0', baseCost: 15, color: '#06b6d4', icon: 'Kling' },
  { id: 'kling-2.6', label: 'Kling 2.6', baseCost: 10, color: '#22d3ee', icon: 'Kling' },
];

export const EDIT_TYPES = [
  { id: 'edit-prompt', label: 'Prompt Edit', cost: 3, icon: '✏️', desc: 'Describe changes to apply' },
  { id: 'edit-add', label: 'Add Object', cost: 3, icon: '➕', desc: 'Add elements to your image' },
  { id: 'edit-remove', label: 'Remove Object', cost: 2, icon: '🗑️', desc: 'Remove unwanted elements' },
  { id: 'edit-angle', label: 'Change Angle', cost: 4, icon: '🔄', desc: 'Change camera angle with consistency' },
  { id: 'inpainting', label: 'Inpainting', cost: 4, icon: '🖌️', desc: 'Paint over areas to regenerate' },
  { id: 'upscale', label: 'Upscale', cost: 3, icon: '🔍', desc: 'Enhance resolution to 4K' },
  { id: 'frame-to-video', label: 'Frame to Video', cost: 8, icon: '🎬', desc: 'Convert image frames to video' },
];

export const UPSCALE_IMAGE_MODELS = [
  { id: 'topaz-image', label: 'Topaz', cost: 25, color: '#f59e0b', icon: 'Topaz', resolutions: ['1x', '2x', '4x', '8x'], resPrices: { '1x': 25, '2x': 45, '4x': 55, '8x': 90 } },
  { id: 'recraft-image', label: 'Recraft', cost: 4, color: '#a78bfa', icon: 'Recraft', hideResolution: true },
];

export const UPSCALE_VIDEO_MODELS = [
  { id: 'topaz-video', label: 'Topaz', cost: 6, color: '#f59e0b', icon: 'Topaz', resolutions: ['1x', '2x', '4x'], resPrices: { '1x': 6, '2x': 12, '4x': 20 } },
  // { id:'grok-imagine', label:'Grok Imagine', cost:8, color:'#e5e7eb', icon:'Grok', hideResolution: true },
];

export const ANGLES_MODELS = [
  // { id: 'qwen', label: 'Qwen', cost: 10, color: '#10a37f', icon: 'Qwen' }, // temporarily disabled
  { id: 'qwen-lora', label: 'Qwen LoRA', cost: 12, color: '#38bdf8', icon: 'Qwen' },
];


export const RATIOS = ['9:16', '2:3', '3:4', '4:5', '1:1', '5:4', '4:3', '3:2', '16:9', '21:9'];
export const RESOLUTIONS = ['720p', '1080p'];
export const DURATIONS = ['5s', '6s', '8s', '12s'];

export const RES_MULT = { '720p': 1, '1080p': 1.5 };
export const DUR_MULT = { '5s': 1, '6s': 1.2, '8s': 1.5, '10s': 2, '12s': 2, '15s': 2.5 };

export const PLANS = [
  {
    id: 'basic', name: 'Basic',
    priceBDT: 399, priceUSD: 3.49, credits: 700,
    features: [
      '700 credits/mo',
      'Total 88 Image',
      'Total 15 Video',
      'Limited model',
      'No Nano Banana Pro',
      'No Flux.2 Max and Flex and Pro',
      'No Kling 3.0',
      '1 month data retention + 7 day grace'
    ],
    klingAccess: false, color: '#3b82f6', retentionMonths: 1,
  },
  {
    id: 'go', name: 'Go',
    priceBDT: 1499, priceUSD: 12.99, credits: 2700,
    features: [
      '2,700 credits/mo',
      'Total 336 Image',
      'Total 54 Video',
      'No Flux.2 Max and Flex',
      'Flux.2 Pro',
      'Kling 3.0',
      '2 months data retention + 7 day grace'
    ],
    klingAccess: 'limited', color: '#8b5cf6', popular: true, retentionMonths: 2,
  },
  {
    id: 'plus', name: 'Plus',
    priceBDT: 3499, priceUSD: 29.99, credits: 6250,
    features: [
      '6,250 credits/mo',
      'Total 782 Image',
      'Total 125 Video',
      'Flux.2 Max and Flex',
      'Fast Generation',
      'More Customised',
      'More Optimized',
      '4 months data retention + 7 day grace'
    ],
    klingAccess: true, color: '#f59e0b', retentionMonths: 4,
  },
];

export const PACKS = [
  { credits: 140, priceBDT: 99, priceUSD: 0.99 },
  { credits: 430, priceBDT: 299, priceUSD: 2.49 },
  { credits: 870, priceBDT: 599, priceUSD: 4.99 },
  { credits: 1450, priceBDT: 999, priceUSD: 8.49, popular: true },
  { credits: 2900, priceBDT: 1999, priceUSD: 16.99, popular: true },
  { credits: 4400, priceBDT: 2999, priceUSD: 24.99, bonus: 150 },
  { credits: 5900, priceBDT: 3999, priceUSD: 33.49, bonus: 200 },
  { credits: 7350, priceBDT: 4999, priceUSD: 41.99, bonus: 300 },
  { credits: 8800, priceBDT: 5999, priceUSD: 49.99, bonus: 400 },
  { credits: 15000, priceBDT: 9999, priceUSD: 83.49, bonus: 500 },
];

export const NAV_ITEMS = [
  { id: 'generate', label: 'Generate', icon: 'sparkle', grp: 'Create' },
  { id: 'edit', label: 'Edit Image', icon: 'edit', grp: 'Create' },
  { id: 'video', label: 'Video', icon: 'video', grp: 'Create' },
  { id: 'frame2video', label: 'Frame to Video', icon: 'film', grp: 'Create' },
  { id: 'gallery', label: 'My Creations', icon: 'grid', grp: 'Library' },
  { id: 'profile', label: 'Profile', icon: 'user', grp: 'Account' },
  { id: 'subscription', label: 'Subscription', icon: 'crown', grp: 'Account' },
];

export const LOADING_STAGES = [
  { key: 'analyzing', label: 'Analyzing prompt', icon: '🧠' },
  { key: 'generating', label: 'Generating content', icon: '⚡' },
  { key: 'rendering', label: 'Rendering output', icon: '🎨' },
  { key: 'finalizing', label: 'Finalizing & uploading', icon: '✅' },
];
